const mutations = {
  IS_LOADING (state, value) {
    state.isLoading = value
  },
  SHOW_EYECATCH (state, value) {
    state.showEyecatch = value
  },
  IS_SMARTPHONE (state, value) {
    state.isSmartPhone = value
  },
  PAGE_TITLE (state, value) {
    state.pageTitle = value
  },
  NAVI_ALL (state, value) {
    state.navi.all = value
  },
  NAVI_LIST (state, value) {
    state.navi.list = value
  },
  NAVI_CURRENT_POS (state, value) {
    state.navi.currentPos = value
  },
  NAVI_ITEM_WIDTH (state, value) {
    state.navi.width = value
  },
  PARAMS_QUERY (state, value) {
    state.params = value
  },
  ANSWERS (state, value) {
    state.answers = value
  },
  GET_SP_DIR (state, value) {
    state.getSpDir = value
  },
  MODAL_SHOW (state, value) {
    state.modal.show = value
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js